import { render, staticRenderFns } from "./NewVenueUsers.vue?vue&type=template&id=06ba7c3c&scoped=true&"
import script from "./NewVenueUsers.vue?vue&type=script&lang=js&"
export * from "./NewVenueUsers.vue?vue&type=script&lang=js&"
import style0 from "./NewVenueUsers.vue?vue&type=style&index=0&id=06ba7c3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba7c3c",
  null
  
)

export default component.exports